import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Card, Input, Space, Typography } from 'antd';
import { DeleteOutlined, CopyOutlined, SaveOutlined, EditOutlined } from "@ant-design/icons";
import { updateResponseById, removeResponseById } from '../Store/slices/gpt.slice';

const { TextArea } = Input;

const EditableResponse = ({ response }) => {
    console.log("EditableResponse: ", response)
    const dispatch = useDispatch();
    const [editableContent, setEditableContent] = useState('');
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        setEditableContent(response.data);
    }, [response]);

    const handleRemoveClick = () => {
        dispatch(removeResponseById(response.id));
    };

    const handleCopyClick = () => {
        navigator.clipboard.writeText(response.data)
          .then(() => {
            console.log('Response copied to clipboard');
          })
          .catch((error) => {
            console.error('Failed to copy response: ', error);
          });
    };

    const handleSaveClick = () => {
        dispatch(updateResponseById({ id: response.id, data: editableContent }));
        setIsEditing(false);
    };

    const handleEditClick = () => {
        setIsEditing(true);
    };

    return (
        <Card
            bordered={false}
            style={{
                background: 'transparent',
            }}
            title={
                <Space>
                    <Typography.Text style={{ marginRight: 'auto' }}>
                        {response.timestamp}
                    </Typography.Text>
                    <Button
                        type="link"
                        icon={<DeleteOutlined />}
                        onClick={handleRemoveClick}
                    />
                    <Button
                        type="link"
                        icon={<CopyOutlined />}
                        onClick={handleCopyClick}
                    />
                    {isEditing ? (
                        <Button
                            type="link"
                            icon={<SaveOutlined />}
                            onClick={handleSaveClick}
                        />
                    ) : (
                        <Button
                            type="link"
                            icon={<EditOutlined />}
                            onClick={handleEditClick}
                        />
                    )}
                </Space>
            }
        >
            {isEditing ? (
                <TextArea
                    value={editableContent}
                    onChange={e => setEditableContent(e.target.value)}
                    autoSize={{ minRows: 10, maxRows: 30 }}
                />
            ) : (
                <div style={{ fontFamily: "Montserrat, sans-serif" }}>
                    {editableContent}
                </div>
            )}
        </Card>
    );
};

export default EditableResponse;
